import { render, staticRenderFns } from "./VenturiEffectViz.vue?vue&type=template&id=90509af2&scoped=true"
import script from "./VenturiEffectViz.vue?vue&type=script&lang=js"
export * from "./VenturiEffectViz.vue?vue&type=script&lang=js"
import style0 from "./VenturiEffectViz.vue?vue&type=style&index=0&id=90509af2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90509af2",
  null
  
)

export default component.exports